const sha1 = require('sha1');
export default class Employee {
  constructor(API) {
    this.api = API;
  }
  /* CRUD */
  async upsertEmployee(orgID, employeeID, updateObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/organization/' + (orgID ? orgID + '/' : '') + 'employee/' + employeeID;
    req.body = { ...updateObj };
    return await req.exec();
  }
  async deleteEmployee(orgID, employeeID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/organization/' + (orgID ? orgID + '/' : '') + 'employee/' + employeeID;
    return await req.exec();
  }
  async getEmployee(orgID, employeeID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organization/' + (orgID ? orgID + '/' : '') + 'employee/' + employeeID;
    return await req.exec();
  }
  /* Custom Read */
  async getEmployeeByEmployeeID(employeeID, expandedOrg) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/employee/' + employeeID + (expandedOrg ? '?expandedOrg=true' : '');
    return await req.exec();
  }
  /* List */
  async getEmployeesByOrgID(orgID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organization/' + (orgID ? orgID + '/' : '') + 'employees';
    return await req.exec();
  }
  /* Validation */
  async validateWorksafeID(orgID, worksafeID, forcePlain) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organization/' + orgID + '/employee/validation';
    req.body = { hashedWorksafeID: (forcePlain ? worksafeID : sha1(worksafeID)) };
    return await req.exec();
  }
  /* Search Operations */
  async searchOrganizationsEmployeesByTerm(searchTerm, filters) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organization/employees/search';
    req.body = { searchTerm, filter: filters };
    return await req.exec();
  }
  async searchOrganizationsEmployeesByIDs(userIDs, filters) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organization/employees/search/byIDs';
    req.body = { searchTerm: userIDs, filter: filters };
    return await req.exec();
  }
  async searchEmployeesAutocomplete(value, orgID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organization/employees/search/autocomplete';
    req.body = { value, orgID };
    return await req.exec();
  }
  async exportEmployeesSearch(searchTerm, filters) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organization/employees/search/export';
    req.body = { searchTerm, filter: filters };
    req.bodyType = 'JSON/BLOB';
    return await req.exec();
  }
  async describeEmployeeMembershipsByEmployeeID(employeeID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/employee/' + employeeID + '/memberships';
    return await req.exec();
  }
}
